window._ = require('lodash')

import axios from "axios"
import Echo from 'laravel-echo'

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

let token = document.head.querySelector('meta[name="csrf-token"]')
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

// Use this when using websocket
/**
 window.Pusher = require('pusher-js')
 window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    disableStats: true
})
 **/
